import React from 'react';

const AsyncVideoClipPage = React.lazy(() => import('./VideoClipContainer'));

export const VideoClipPage = () => {
  return <AsyncVideoClipPage />;
};
